(function (window, document, $, undefined) {
	$(function () {
		$(".js-header-toggler").each(function () {
			var $this = $(this);

			console.log($this);

			$this.on("click", function (e) {
				e.preventDefault();

				if ($(".js-header-bottom").length > 0) {
					$(".js-header-bottom").toggleClass("open");
					$("body").toggleClass("noscroll");
				}
			});
		});
	});
})(window, document, jQuery);
